export const enum PersonalAlbumsPageTabs {
    all = 'all',
    shared = 'shared',
    family = 'family',
}
